@if (messageContent) {
  <div class="shot-image-container">
    <!-- Image information -->
    <div class="viz-header">
      <div class="viz-title">{{ image_information.job_name }}</div>
      <div class="viz-meta">
        {{
        this.image_information.shot_id &&
        "Shot: " + image_information.shot_id + " | "
        }}
        Iteration:
        {{ image_information.iteration }}
      </div>
    </div>
    <nz-divider class="viz-divider"></nz-divider>
    <nz-spin [nzSpinning]="loading">
      <div class="viz-layout">
        <div class="shrink-container" [class.shrinkHide]="hide_settings">
          <div class="content-wrapper">
            <button
              nz-button
              (click)="hide_settings = true"
              nzSize="small"
              class="viz-panel-fold"
              >
              <span nz-icon nzType="menu-fold" nzTheme="outline"></span>
            </button>
            <nz-input-group class="legacy-input-styling viz-field">
              <label class="viz-field-label">Panel</label>
              <nz-select
                class="viz-field-control"
                [(ngModel)]="panel_type"
                (ngModelChange)="handlePanelTypeChange($event)"
                >
                @for (panel_opt of ['Field', 'Predicted', 'Interleaved']; track panel_opt) {
                  <nz-option
                    [nzValue]="panel_opt"
                    [nzLabel]="panel_opt"
                  ></nz-option>
                }
              </nz-select>
            </nz-input-group>
            @if (request_body?.interleave_attrs?.is_interleave) {
              <nz-input-group
                class="legacy-input-styling viz-field"
                >
                <label class="viz-field-label">Interleave Extent</label>
                <input
                  nz-input
                  [(ngModel)]="request_body.interleave_attrs.extent"
                  />
              </nz-input-group>
            }
            <nz-input-group class="legacy-input-styling viz-field">
              <label class="viz-field-label">Data Type</label>
              <nz-select class="viz-field-control" [(ngModel)]="request_body.type">
                @for (data_type of ['lowpass-B4', 'compare']; track data_type) {
                  <nz-option
                    [nzValue]="data_type"
                    [nzLabel]="data_type"
                  ></nz-option>
                }
              </nz-select>
            </nz-input-group>
            <nz-input-group class="legacy-input-styling viz-field">
              <label class="viz-field-label">Scaling</label>
              <nz-input-number
                class="viz-field-control"
                [(ngModel)]="scaling"
                (ngModelChange)="onScalingChange()"
              ></nz-input-number>
            </nz-input-group>
            <nz-input-group class="viz-field-row" nzCompact>
              <nz-input-group
                class="legacy-input-styling viz-field viz-field--flush"
                >
                <label class="viz-field-label">Start Trace</label>
                <input
                  type="number"
                  nz-input
                  [(ngModel)]="request_body.start_trace"
                  />
              </nz-input-group>
              <nz-input-group
                class="legacy-input-styling viz-field viz-field--flush"
                >
                <label class="viz-field-label">End Trace</label>
                <input
                  type="number"
                  nz-input
                  [(ngModel)]="request_body.end_trace"
                  />
              </nz-input-group>
            </nz-input-group>
            <button nz-button nzType="primary" (click)="get_image(true)" class="viz-panel-update">
              Update
            </button>
          </div>
        </div>
        <div
          id="image-box"
          #sliceImageContainer
          class="viz-image-box"
          >
          <!-- the calc height is to regulate with the 50px of the coloarbar, and 10px gap.
          Since its a SVG element, its sort of complicated to make it dynamically size correctly hence the
          sort of hacky solution -->
          <button
            nz-button
            nzType="primary"
            [nzGhost]="true"
            (click)="add_image_to_flipper()"
            class="add-image-to-flipper-button"
            nzSize="small"
            nz-tooltip
            nzTooltipTitle="Add to image flipper"
            >
            <span nz-icon nzType="select" nzTheme="outline"></span>
          </button>
          @if (hide_settings) {
            <button
              nz-button
              nzType="primary"
              [nzGhost]="true"
              (click)="hide_settings = false"
              class="open-image-settings-button"
              nzSize="small"
              >
              <span nz-icon nzType="menu-unfold" nzTheme="outline"></span>
            </button>
          }
        </div>
        <div
          id="colorbar-box"
          class="viz-colorbar"
          >
          <span class="viz-colorbar-label">{{
            request_body.scaling[1]?.toExponential(3)
          }}</span>
          <div class="viz-colorbar-gradient"></div>
          <span class="viz-colorbar-label">{{
            request_body.scaling[0]?.toExponential(3)
          }}</span>
        </div>
      </div>
    </nz-spin>
  </div>
}
